import _ from 'lodash'

var alphabetic = {

	// test if the given text contains only alphabetic characters
	test: function(str) {
		if (!this._pattern) {
			// https://stackoverflow.com/a/62032796/393274
			this._pattern = new RegExp(/^\p{L}/,'u')
		}

		return _.isString(str) && this._pattern.test(str)
	}

}

export default alphabetic

alphabetic.__filename__ = 'components/alphabetic.js'
